import styles from "./FormStyles.module.css";
import PropTypes from "prop-types";

// --| This component will be used as a select for every forms used. it returns a label and input with props
const SelectGroup = ({ label, children }) => (
  <div className={ styles.selectwrapper }>
    <p>{label}</p>
    {children}
  </div>
);

SelectGroup.propTypes = {
  label: PropTypes.string,
  children: PropTypes.any
};

export default SelectGroup;
